"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _draftExtend = require("draft-extend");

var _constants = require("composer-plugins/lib/constants");

var _react = _interopRequireDefault(require("react"));

// Very basic Draft plugin to style a highlighted selection of text in the editor
// To use, apply HIGHLIGHT_ENTITY_TYPE entity to the selection to be highlighted
// and add CSS styles for the className provided by this decorator.
var HighlightDecorator = {
  strategy: _draftExtend.pluginUtils.entityStrategy(_constants.HIGHLIGHT_ENTITY_TYPE),
  component: function component(_ref) {
    var children = _ref.children;
    return _react.default.createElement("span", {
      className: "highlighted-by-conversation"
    }, children);
  }
};

var _default = function _default() {
  return (0, _draftExtend.createPlugin)({
    displayName: 'HighlightPlugin',
    decorators: HighlightDecorator
  });
};

exports.default = _default;
module.exports = exports.default;